import React from 'react'
import './CardBody.less'

interface ICardBodyProps {
  children: any
  inputRef?: () => void
}

const CardBody = ({ children }: ICardBodyProps) => {
  return <div className="Card__body">{children}</div>
}

export default CardBody
